import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { commons } from '../../hook/common'
import { Link } from 'react-router-dom'
import { authActions, alertActions, mobileActions, userinfoActions, govCertapplyActions } from '../../store/actions'
import $ from 'jquery'
import Clipboard from 'react-clipboard.js'
import axios from 'axios'
import * as Common from '../../assets/js/common.js'
import { isMobile } from 'react-device-detect'
import { useHistory } from 'react-router'
import { addLifecycle, removeLifecycle } from '../../assets/js/native.lifecycle'
import moment from 'moment'
import { checkRequiredParams } from './checkRequiredParams'
import { memberAppActions } from '../../store/actions/main/memberApp.actions'
import { AlternateEmail } from '@material-ui/icons'
import userinfo from '../../store/reducers/userinfo/userinfo.reducer'
import { uriConstants } from '../../store/constants/';
import PasswordConfirmModal from '../../component/home/PasswordConfirmModal'

const DefaultHeader = (props) => {
  const { auth } = props
  const [user, setUser] = useState({})
  const [signdata, setSigndata] = useState('')
  const [urlCode, setUrlCode] = useState('')
  const [deviceId, setDeviceId] = useState('')
  const [showPwdPopup, setShowPwdPopup] = useState(false)
  const history = useHistory()

  useEffect(() => {
    auth?.isLoggedIn && props.load() // : history.replace('/login')
  }, [auth?.isLoggedIn])

  useEffect(() => {
    setUser({
      ...user,
      ...props.userInfo,
    })
    console.log(user)
  }, [props.userInfo])

  useEffect(() => {
    auth?.isLoggedIn && props.pushload()
    setSigndata(
      auth?.user?.payload?.signData
    )
  }, [])
  useEffect(() => {
    // signdata의 변화를 감지하는  부분
    if(props.signData){
      setSigndata(
        props.signData
      )
    }
  }, [props.signData])
  // console.log('push', props.pushData?.length)

  useEffect(() => {
    setUser({
      ...user,
      roleDto: auth?.user?.payload?.roleDto,
    })
  }, [auth])

  useEffect(() => {
    // 개인 전자문서지갑 주소 확인 결과
    let logTest ={}
    logTest.url = 'Header.jsx 54'
    logTest.verifyIndiECDWResult = props.verifyIndiECDWResult
    logTest.signData = signdata
    axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',logTest,{headers:{},})
    if (props.verifyIndiECDWResult?.rspnsCode === '100') {
      console.info('5. 개인 전자문서지갑 주소 확인', props.verifyIndiECDWResult)
      // 1: 등록지갑인 경우 정상 사용 처리, 해당 지갑앱 최초 연계시 '전자증명서 유통발급 서비스 지갑 연계'에 대한 동의를 받아 자체 관리
      if (props.verifyIndiECDWResult?.ecdwTyCode === '1') {
        // user 정부 24 지갑주소 추가
        const loginType = JSON.parse(localStorage.getItem('user'))?.payload?.loginType
        // 대략 이 부근에서 수정 진행하면 될듯...
        // 어차피 인증서 로그인인 경우가 없는 듯 하다 ==> 공동인증서로 로그인 되도록 수정해야 한다.
        // 
        const paramsTest = {
          signedData: signdata,
          ecdwAdres: props.verifyIndiECDWResult?.ecdwAdres,
          urlCode: urlCode,
          deviceId:deviceId,
        }
        Object.assign(paramsTest,{url:'Header.jsx 73'})
        axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',paramsTest,{headers:{},data : paramsTest})
        if(urlCode && props.verifyIndiECDWResult?.ecdwAdres && signdata){
          // 지갑 화면 URL 요청
          props.getScreenURL(paramsTest)
          return
        }
        if (loginType !== 'crtfctf') {
          props.confirm({
            title: '확인',
            message: '공동 인증 로그인 시 이용 가능한 메뉴입니다. \n공동 인증 로그인 화면으로 이동하시겠습니까?',
            params: {
              type: 'confirm',
              okBtnTitle: '지금변경하기',
              cancelBtnTitle: '나중에변경하기',
              cancelCallback: () => {
                return history.goBack()
              },
              callback: () => {
                 return JSON.parse(localStorage.getItem('user'))?.payload?.roleDto?.roleId === 3
                   ? history.replace('/login?'+urlCode+'='+props.verifyIndiECDWResult?.ecdwAdres)
                   : history.replace('/loginCorp?'+urlCode+'='+props.verifyIndiECDWResult?.ecdwAdres)
                //return history.replace('/login?urlCode='+urlCode)
              },
            },
          })
        }

        // const params = {
        //   deviceId: deviceId,
        //   ecdwAdres: props.verifyIndiECDWResult.ecdwAdres,
        //   signData: JSON.parse(localStorage.getItem('user'))?.payload?.signData,
        //   urlCode,
        // }
        // if (checkRequiredParams(params)) {
        //   // 지갑 화면 URL 요청
        //   props.getScreenURL(params)
        // } else {
        //   console.error('지갑등록유형 코드 = 1, 지갑 화면 URL 요청 params:', params)
        //   return egovAlertMessage()
        // }
        // setUser({ ...user, ecdwAdres: props.verifyIndiECDWResult?.ecdwAdres })
      }
      // 2: 미등록 지갑인 경우 지갑 이용자 약관 동의 후 지갑 발급 처리(6, 1 API 활용)
      else if (props.verifyIndiECDWResult?.ecdwTyCode === '2') {
        const params = {
          deviceId: deviceId, // 모바일 디바이스 ID
          // ci 는 보내지 않는다 — 서버가 로그인 사용자의 CI 를 직접 조회한다(응답 CI 제거)
          agrmntAgreAt: 'Y', // 약관동의여부
          agrmntAgreDe: moment().format('YYYYMMDD'), // 약관동의일자 (yyyyMMdd)
          birthDe: user.birthDay, // 생년월일 (yyyyMMdd)
          moblphonNo: user.mobileNo, // 휴대폰번호
          nm: user.memberName, // 성명
          ntvfrnrSeCode: user.nativeYn, // 내외국인 구분 - Y: 내국인 - N: 외국인
          sexdstnCode: user.genderCd === 'M' ? 'Y' : 'N', // 성별 - Y: 남성 - N: 여성
        }

        if (checkRequiredParams(params)) {
          // 약관동의 내용 조회
          props.inquireIndiStipAgree(params)
          // 개인 전자문서지갑 주소 발급
          props.issueIndiECDW(params)
        } else {
          console.error('지갑등록유형 코드 = 2, 미등록 지갑인 경우 지갑 이용자 약관 동의 후 지갑 발급 처리 params:', params)
          return egovAlertMessage()
        }
      }
      // 3: 미등록 장치인 경우 지갑 이용자 장치 변경 팝업함 메세지 표시 후 기기 변경 처리(8-1, 2 API 활용)
      else if (props.verifyIndiECDWResult?.ecdwTyCode === '3') {
        const params = {
          deviceId: deviceId, // 모바일 디바이스 ID
          ecdwAdres: props.verifyIndiECDWResult?.ecdwAdres,
        }

        if (checkRequiredParams(params)) {
          // 개인 전자문서지갑 팝업함 조회
          props.inquireIndiECDWPopupList(params)
        } else {
          console.error('지갑등록유형 코드 = 3, 개인 전자문서지갑 팝업함 조회 params:', params)
          return egovAlertMessage()
        }
      }
      // 5: 약관변경인 경우 다시 지갑 이용자 동의 처리(6, 2 API 활용)
      else if (props.verifyIndiECDWResult?.ecdwTyCode === '5') {
        const params = {
          deviceId: deviceId, // 모바일 디바이스 ID
        }

        if (checkRequiredParams(params)) {
          // 약관동의 내용 조회
          props.inquireIndiStipAgree(params)
        } else {
          console.error('지갑등록유형 코드 = 5, 약관동의 내용 조회 params:', params)
          return egovAlertMessage()
        }
      }
      // 6: 전화번호 변경인 경우 이용자에게 고지하고 API이용 기관에 이용자 전화번호 갱신 필요
      else if (props.verifyIndiECDWResult?.ecdwTyCode === '6') {
        console.warn('전화번호 변경인 경우 이용자에게 고지하고 API이용 기관에 이용자 전화번호 갱신 필요.')
        const params = {
          deviceId: deviceId, // 모바일 디바이스 ID
        }

        if (checkRequiredParams(params)) {
          // 약관동의 내용 조회
          props.inquireIndiStipAgree(params)
        } else {
          console.error('지갑등록유형 코드 = 6, 약관동의 내용 조회 params:', params)
          return egovAlertMessage()
        }
      } else {
        console.error('지갑등록유형 코드이 어떤 값인지 파악이 되지 않습니다.')
      }
    }else if (props.verifyIndiECDWResult) {
      console.error(props.verifyIndiECDWResult)
    }
  }, [props.verifyIndiECDWResult])

  useEffect(() => {
    if (props.screenURL?.rspnsCode === '100') {
      console.info('85. 지갑 화면 URL 요청', props.screenURL)
      if (Common.getDeviceType() === 'MobileApp') {
        window.M.execute('exWNStartViewElecDocActivity', props.screenURL?.url)
        // 수정예정
        history.replace('/')
      } else {
         props.error({ title: '확인', message: '모바일만 이용 가능한 메뉴입니다.' })
      }
    } else if (props.screenURL) {
      console.error(props.screenURL)
    }
  }, [props.screenURL])

  useEffect(() => {
    if (props.inquireIndiStipAgreeResult) {
      console.log('6. 약관동의 내용 조회', props.inquireIndiStipAgreeResult)
    }
  }, [props.inquireIndiStipAgreeResult])

  useEffect(() => {
    if (props.issueIndiECDWResult?.rspnsCode === '100') {
      console.log('1. 개인 전자문서지갑 주소 발급', props.issueIndiECDWResult)
      const params = {
        agrmntAgreAt: 'Y', // 약관동의여부
        //agrmntAgreDe: moment(user.mobileCertDt).format('YYYYMMDD')
        agrmntAgreDe: moment().format('YYYYMMDD'), // 약관동의일자 (yyyyMMdd)
        ecdwAdres: props.verifyIndiECDWResult?.ecdwAdres, // 전자문서지갑 주소
        deviceId: deviceId, // 모바일 디바이스 ID
        moblphonNo: user.mobileNo, // 휴대폰번호
        useAt: 'Y', // 이용여부 ㆍBoolean - Y: 이용 - N: 이용정지
      }

      if (checkRequiredParams(params)) {
        // 개인 전자문서지갑 주소 정보 변경
        props.changeIndiECDWInfo(params)
      } else {
        console.error('개인 전자문서지갑 주소 정보 변경 params:', params)
        return egovAlertMessage()
      }
    } else if (props.issueIndiECDWResult) {
      console.error(props.issueIndiECDWResult)
    }
  }, [props.issueIndiECDWResult])

  useEffect(() => {
    if (props.inquireIndiECDWPopupListResult?.rspnsCode === '100') {
      console.info('8-1. 개인 전자문서지갑 팝업함 조회', props.inquireIndiECDWPopupListResult)
      const params = {
        agrmntAgreAt: 'Y', // 약관동의여부
        agrmntAgreDe: moment().format('YYYYMMDD'), // 약관동의일자 (yyyyMMdd)
        ecdwAdres: props.verifyIndiECDWResult?.ecdwAdres, // 전자문서지갑 주소
        deviceId: deviceId, // 모바일 디바이스 ID
        moblphonNo: user.mobileNo, // 휴대폰번호
        useAt: 'Y', // 이용여부 ㆍBoolean - Y: 이용 - N: 이용정지
      }

      if (checkRequiredParams(params)) {
        // 개인 전자문서지갑 주소 정보 변경
        props.changeIndiECDWInfo(params)
      } else {
        console.error('개인 전자문서지갑 주소 정보 변경 params:', params)
        return egovAlertMessage()
      }
    } else if (props.inquireIndiECDWPopupListResult) {
      console.error(props.inquireIndiECDWPopupListResult)
    }
  }, [props.inquireIndiECDWPopupListResult])

  useEffect(() => {
    if (props.inquireIndiStipAgreeResult?.rspnsCode === '100') {
      console.info('6. 약관동의 내용 조회', props.inquireIndiStipAgreeResult)
      const params = {
        agrmntAgreAt: 'Y', // 약관동의여부
        agrmntAgreDe: moment().format('YYYYMMDD'), // 약관동의일자 (yyyyMMdd)
        ecdwAdres: props.verifyIndiECDWResult?.ecdwAdres, // 전자문서지갑 주소
        deviceId: deviceId, // 모바일 디바이스 ID
        moblphonNo: user.mobileNo, // 휴대폰번호
        useAt: 'Y', // 이용여부 ㆍBoolean - Y: 이용 - N: 이용정지
      }

      if (checkRequiredParams(params)) {
        // 개인 전자문서지갑 주소 정보 변경
        props.changeIndiECDWInfo(params)
      } else {
        console.error('개인 전자문서지갑 주소 정보 변경 params:', params)
        return egovAlertMessage()
      }
    } else if (props.inquireIndiStipAgreeResult) {
      console.error(props.inquireIndiStipAgreeResult)
    }
  }, [props.inquireIndiStipAgreeResult])

  useEffect(() => {
    if (props.changeIndiECDWInfoResult?.rspnsCode === '100') {
      console.info('2. 개인 전자문서지갑 주소 정보 변경', props.changeIndiECDWInfoResult)
      const params = {
        deviceId: deviceId,
        moblphonNo: user.mobileNo,
      }

      if (checkRequiredParams(params)) {
        // 개인 전자문서지갑 주소 확인 (verifyIndiECDW)
        props.verifyIndiECDW(params)
      } else {
        console.error('개인 전자문서지갑 주소 확인 params:', params)
        return egovAlertMessage()
      }
    } else if (props.changeIndiECDWInfoResult) {
      console.error(props.changeIndiECDWInfoResult)
    }
  }, [props.changeIndiECDWInfoResult])

  useEffect(() => {
    if (commons.isMobile() && auth.isLoggedIn) {
      props.count()
    }
    if (Common.getDeviceType() === 'MobileApp' && auth.isLoggedIn) {
      setDeviceId(window.M.info.device('uuid'))
    }
    // let temp ={uuid : deviceId,propsUuid : props?.deviceId}
    // let paramStr = JSON.parse(temp)
    // axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',paramStr,{headers:{},data : paramStr})
    const onBackEvent = () => {
      if (history.location.pathname === '/') {
        return window.M.pop.alert({
          title: '알림',
          message: '앱을 종료하시겠습니까?',
          buttons: ['확인', '취소'],
          callback: function (idx) {
            if (idx === 0) {
              window.M.sys.exit()
            }
          },
        })
      }
      // 케이스 1, 더이상 뒤로 갈수 없는 경우을 체크할 수 있는 경우
      else if (history.length > 1) {
        // history.go(-1)
        history.goBack()
      }
    }

    // 단말기에서 Back 키가 눌려졌을때 호출 (Only Android)
    if (Common.getDeviceType() === 'MobileApp' && window.M.navigator.device('android')) {
      addLifecycle('onback', onBackEvent)
    }

    return () => {
      if (Common.getDeviceType() === 'MobileApp' && window.M.navigator.device('android')) {
        removeLifecycle('onback', onBackEvent)
      }
    }
  }, [])

  useEffect(() => {
    //gnb
    $('#gnb>ul>li>a').bind('mouseenter focusin', function () {
      if ($('#gnb').height() < 87) {
        $('#gnb').stop().animate({ height: 305 }, 250).addClass('active')
      }
      $('#gnb>ul>li.on').removeClass('on')
      $(this).parent().addClass('on')
    })
    $('#gnb ul.submenu>li').bind('mouseenter focusin', function () {
      if (!$(this).parent().parent().hasClass('on')) {
        $('#gnb>ul>li.on').removeClass('on')
        $(this).parent().parent().addClass('on')
        if ($('#gnb').height() > 87) {
          $('#gnb').css('height', '305px')
        }
      }
    })
    $('#gnb').bind('mouseleave', function () {
      $('#gnb>ul>li.on').removeClass('on')
      $('#gnb').stop().animate({ height: 86 }, 50).removeClass('active')
    })

    //nav mobile
    function showSidebar() {
      sidebar.css('margin-right', '0')
      overlay.show(0, function () {
        overlay.fadeTo('300', 0.3)
      })
    }
    function hideSidebar() {
      sidebar.css('margin-right', sidebar.width() * -1 + '%')
      overlay.fadeTo('300', 0, function () {
        overlay.hide()
      })
    }
    var sidebar = $('.aside-nav')
    var button = $('.all-menu')
    var overlay = $('.page-overlay')

    overlay.parent().css('min-height', 'inherit')
    sidebar.css('margin-right', sidebar.width() * -1 + '%')
    sidebar.show(0, function () {
      sidebar.css('transition', 'all 0.3s ease')
    })
    button.click(function () {
      if (overlay.is(':visible')) {
        hideSidebar()
        $(this).removeClass('on')
      } else {
        showSidebar()
        $(this).addClass('on')
      }
      return false
    })
    overlay.click(function () {
      hideSidebar()
      button.removeClass('on')
    })

    $('.lnb .submenu li').addClass('menu')
    $('.lnb .submenu li.dep-menu').removeClass('menu')
    var hideaside = $(
      '.aside-nav .lnb .submenu li.menu a,.aside-nav .lnb .submenu li.dep-menu.current li a,.aside-header .member-link a,.aside-header .menu-link a,.aside-nav .aside-btm a',
    )
    hideaside.click(function () {
      hideSidebar()
      button.removeClass('on')
    })

    //lnb
    $('.lnb>li').on('click', function () {
      $(this).addClass('on').siblings().removeClass('on')
    })
    $('.lnb .submenu li a').on('click', function () {
      var element = $(this).parent('li')
      if (element.hasClass('current')) {
        element.removeClass('current')
        element.find('li').removeClass('current')
        element.find('ul').slideUp(200)
      } else {
        element.addClass('current')
        element.children('ul').slideDown(200)
        element.siblings('li').children('ul').slideUp(200)
        element.siblings('li').removeClass('current')
      }
    })

    // utility
    $('.utility .menu-link a').on('click', function () {
      $(this).addClass('on').siblings('a').removeClass('on')
    })
    $('.utility .member-link .my-name').click(function () {
      $(this).parent().next('.my-link').toggleClass('active')
    })
    $('html').click(function (e) {
      if (!$(e.target).hasClass('my-name')) {
        $('.my-link').removeClass('active')
      }
    })
    $('.join-intro a').on('click', function () {
      $(this).addClass('on').siblings('a').removeClass('on')
    })

    $('.login-select a').on('click', function () {
      $(this).addClass('on').siblings('a').removeClass('on')
    })

    $('.attach-wrap .attach-link').click(function (e) {
      e.preventDefault()
      $(this).next('.attach-file').toggleClass('active')
      $(this).parent().parent().parent().siblings('tr').children('td').find('.attach-file').removeClass('active')
    })
    $('html').click(function (e) {
      if (!$(e.target).hasClass('attach-link')) {
        $('.attach-file').removeClass('active')
      }
    })

    //tab
    var $tabsNav = $('.tabs'),
      $tabsNavLis = $tabsNav.children('li'),
      $tabContent = $('.tab-cont')
    $tabsNav.each(function () {
      var $this = $(this)
      $this.next().children('.tab-cont').stop(true, true).hide().first().show()
      $this.children('li').first().addClass('on').stop(true, true).show()
    })
    $tabsNavLis.on('click', function (e) {
      var $this = $(this)
      $this.siblings().removeClass('on').end().addClass('on')
      $this.parent().next().children('.tab-cont').stop(true, true).hide().siblings($this.find('a').attr('href')).fadeIn(300)
      e.preventDefault()
    })

    //toggle
    $('.toggle-cont').first().show()
    $('.toggle-tit span').first().addClass('on')
    $('.toggle-tit span').click(function () {
      if (!$(this).hasClass('on')) {
        $(this).parent().next('.toggle-cont').animate({ height: 'toggle' }, 100)
        $(this).addClass('on')
      } else {
        $(this).parent().next('.toggle-cont').animate({ height: 'toggle' }, 100)
        $(this).removeClass('on')
      }
      return false
    })

    //toggle list
    var atc = $('.toggle-list > li')
    atc.addClass('hid')
    $('.toggle-list > li > a').click(function (e) {
      var atcm = $(this).parents('.toggle-list > li:first')
      if (atcm.hasClass('hid')) {
        atc.addClass('hid').removeClass('on').next('.cont').slideUp(150)
        atcm.removeClass('hid').addClass('on').next('.cont').slideDown(150)
      } else {
        atcm.removeClass('on').addClass('hid').next('.cont').slideUp(150)
      }
      return false
    })

    $('.nav-wrap .current-menu').click(function (e) {
      e.preventDefault()
      $(this).toggleClass('on')
    })

    $('.info-toggle').click(function (e) {
      e.preventDefault()
      $(this).toggleClass('on')
      $(this).parent().parent().parent().next('tbody').animate({ height: 'toggle' }, 100)
    })
  }, [])

  function pinRegist() {
    document.querySelector('.all-menu').click()
    if (window.M.navigator.device('ios')) {
      // ios일 경우
      var params = {}
      params.length = '6'
      params.activity = 'SamplePassCodeViewController'
      window.M.plugin('3rd_iOS_pin_basic').register({
        param: params,
        callback: function (status, result) {
          console.log('status : ' + status)
          console.log('result : ' + JSON.stringify(result))
        },
      })
    } else if (window.M.navigator.device('android')) {
      // android일 경우
      window.M.execute('exWNPinLockActivity', {
        length: 6,
        type: 'REGISTER',
        callback: window.M.response
          .on(function (status, result) {
            console.log(status)
            console.log(result)
          })
          .toString(),
      })
    }
  }

  const ewalletIdCopy = () => {
    props.error({ title: '확인', message: '"내지갑 주소"가 클립보드에 저장되었으니 붙여넣기로 이용하세요.' })
  }

  const login = () => {
    window.location.href = 'https://wallet.utradehub.or.kr/loginIntro'
  }
  const crtfctMng = () => {
    if (isMobile) {
      //window.location.href = '/crtfct/mng'
      window.location.href = '/crtfct/mngMobile'
    } else {
      window.location.href = '/crtfct/mng'
    }
  }

  // const openUth = () => {
  //   history.push('/openLink')
  // }
  const hideAsideNav = () => {
    // $('.aside-nav').css('margin-right', $('.aside-nav').width() * -1 + '%')
    // $('.page-overlay').fadeTo('300', 0, function () {
    //   $('.page-overlay').hide()
    // })
    $('.all-menu').trigger('click')
  }

  function qrLogin() {
    let userInfo = localStorage.getItem('user')
    if (userInfo !== null) {
      window.M.plugin('qr').scan({
        flash: false,
        fadeToggle: false,
        orientation: 'PORTRAIT',
        page: 'CustomQRActivity',
        filterType: 'QRCODE',
        onscan: function (result) {
          if (result.status === 'NS') {
            console.log('This QRCode Plugin is not supported')
          } else if (result.status === 'CANCEL') {
            console.log('Scanning is canceled')
          } else if (result.status !== 'SUCCESS') {
            if (result.message) {
              console.log(result.status + ':' + result.message)
            } else {
              console.log('This QRCode Plugin is failed')
            }
          } else {
            if (result.text) {
              console.log(result.format + ':' + result.text)
              let memberId = window.M.data.storage('memberId')
              return axios.post(result.text + memberId)
            } else {
              console.log('QRCode data is not scanning')
            }
          }
        },
      })
    } else {
      window.location.href = '/loginintro'
      // window.M.pop.instance('로그인을 하셔야 합니다.')
    }
  }

  function patternInfoAdd() {
    document.querySelector('.all-menu').click()
    if (window.M.navigator.device('ios')) {
      // ios일 경우
      window.M.plugin('3rd_iOS_pattern_basic').lock({
        type: 'reset',
        callback: function (status, result) {
          if (result.result == 'SUCCESS') {
            // 패턴 재설정 및 인증 성공
            window.M.pop.instance('패턴 등록이 되었습니다.')
            console.log('result message : ' + result.message)
          } else if (result.result == 'FAIL') {
            // 패턴인증 취소
            window.M.pop.instance('패턴 등록이 취소 되었습니다.')
            console.log('resutl message : ' + result.message)
          }
        },
      })
    } else if (window.M.navigator.device('android')) {
      //android일 경우
      window.M.execute('exWNPatternLockActivity', {
        type: 'reset',
        callback: window.M.response
          .on(function (status, result) {
            if (result.result == 'SUCCESS') {
              // 패턴 재설정 및 인증 성공
              window.M.pop.instance('패턴 등록이 되었습니다.')
              console.log('result message : ' + result.message)
            } else if (result.result == 'FAIL') {
              // 패턴인증 취소
              window.M.pop.instance('패턴 등록이 취소 되었습니다.')
              console.log('resutl message : ' + result.message)
            }
            //console.log(status);
            //console.log(result);
          })
          .toString(),
      })
    }
  }

  //생체인증
  function bioCheck() {
    document.querySelector('.all-menu').click()
    if (window.M.navigator.device('ios')) {
      // ios일 경우
      window.M.plugin('3rd_iOS_fingerprint_basic').check({
        callback: function (status, result) {
          console.log('status : ' + status)
          console.log('result : ' + JSON.stringify(result))
          //    window.M.pop.alert('result : ' + JSON.stringify(result));
          if (result.result == 'SUCCESS') {
            //생체등록가능
            bioInfoAdd()
          } else {
            window.M.pop.instance('생체인증을 지원하지 않습니다.')
          }
        },
      })
    } else if (window.M.navigator.device('android')) {
      // android일 경우
      window.M.plugin('3rd_fingerprint_basic').check({
        callback: function (status, result) {
          console.log(status + JSON.stringify(result))
          //  window.M.pop.alert('result : ' + JSON.stringify(result));
          if (result.result == 'SUCCESS') {
            bioInfoAdd()
          } else {
            window.M.pop.instance('생체인증을 지원하지 않습니다.')
          }
        },
      })
    }
  }
  function bioInfoAdd() {
    if (window.M.navigator.device('ios')) {
      // ios일 경우
      var result = window.M.plugin('3rd_iOS_fingerprint_basic').moveSetting()
      console.log('result : ' + JSON.stringify(result))
      // window.M.pop.alert('result : ' + JSON.stringify(result));
    } else if (window.M.navigator.device('android')) {
      // android일 경우
      var result = window.M.plugin('3rd_fingerprint_basic').moveSetting()
      console.log('result : ' + JSON.stringify(result))
      //window.M.pop.alert('result : ' + JSON.stringify(result));
      //   window.M.pop.alert('result : ' + JSON.stringify(result) +","+"bioInfoAdd");
    }
  }

  // 정부전자문서지갑 Click Event
  const openECDW = (urlCode) => {
    if (Common.getDeviceType() === 'MobileApp') {
      if (!auth?.isLoggedIn) {
        props.error({ title: '확인', message: '로그인 시 이용 가능한 메뉴입니다.' })
        return history.replace('/loginIntro')
      }

      // const loginType = JSON.parse(localStorage.getItem('user'))?.payload?.loginType
      // if (loginType !== 'crtfctf') {
      //   console.log('loginType', loginType)
      //   props.confirm({
      //     title: '확인',
      //     message: '공동 인증 로그인 시 이용 가능한 메뉴입니다. \n공동 인증 로그인 화면으로 이동하시겠습니까?',
      //     params: {
      //       type: 'confirm',
      //       okBtnTitle: '지금변경하기',
      //       cancelBtnTitle: '나중에변경하기',
      //       cancelCallback: () => {
      //         return history.goBack()
      //       },
      //       callback: () => {
      //          return JSON.parse(localStorage.getItem('user'))?.payload?.roleDto?.roleId === 3
      //            ? history.replace('/login')
      //            : history.replace('/loginCorp')
      //       },
      //     },
      //   })
      // }
      const params = {
        // deviceId: deviceId,
        moblphonNo: user.mobileNo,
      }
      
      console.log('openECDW.params', params)
      params.url = 'Header.jsx 739'
      axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',params,{headers:{},})
      if (checkRequiredParams(params)) {
        if(deviceId){
          params.deviceId = deviceId
        }
        // 1. 개인 전자문서지갑 주소 확인 (verifyIndiECDW)
        props.verifyIndiECDW(params)
      } else {
        console.error('개인 전자문서지갑 주소 확인 params:', params)
        return egovAlertMessage()
      }
    } else {
      props.error({ title: '확인', message: '모바일만 이용 가능한 메뉴입니다.' })
    }
    setUrlCode(urlCode)
  }

  const egovAlertMessage = () => {
    props.error({
      title: '휴대폰 본인인증 업데이트 필요',
      message:
        '정부 전자문서 지갑을 이용하시려면 휴대폰 본인인증 업데이트가 필요합니다.\n 위치: [ 마이페이지 > 휴대폰 번호 - 본인인증 후 저장 ]\n이 알림 메시지가 지속되면 관리자에게 문의하세요.',
    })
  }

  //gnb 관련 script
  const gnbClickHandler = () => {
    $('#gnb>ul>li.on').removeClass('on')
    $('#gnb').stop().animate({ height: 86 }, 50).removeClass('active')
  }

  return (
    <React.Fragment>
      <div id="header">
        <div className="inner">
          <h1>
            <Link to="/">전자문서지갑</Link>
          </h1>
          <div className="utility">
            <div className="menu-link">
              {auth?.isLoggedIn && (
                <Link to="#" onClick={() => props.logOut('/')} className="on">
                  로그아웃
                </Link>
              )}

              {Common.getDeviceType() !== 'MobileApp' && (
                <a
                  href={window.location.href.includes('test') ? 'https://dev-sign.utradehub.or.kr' : 'https://sign.utradehub.or.kr'}
                  target="_blank"
                >
                  전자계약
                </a>
              )}
              {Common.getDeviceType() !== 'MobileApp' && (
                !auth?.isLoggedIn &&(<Link to="/service/verify/nm">진본검증</Link>)
              )}
            </div>
            <div className="member-link">
              {auth?.isLoggedIn ? (
                <>
                  {/* 로그인후 */}
                  <span className="name" style={user?.roleDto?.roleId === 3 ? { cursor: 'pointer' } : { cursor: 'auto' }}>
                    {user.groupName ? (
                      <em>
                        {user.groupName}({user.memberId})
                      </em>
                    ) : (
                      ''
                    )}
                    <strong className="my-name">{user.memberName}</strong>님
                    {user?.roleDto?.roleNm &&(<em style={{marginTop:"7px"}}>{user?.roleDto?.roleId ==3 ?(user?.roleDto?.roleNm +' 회원'):(user?.roleDto?.roleNm)}</em>)}
                  </span>
                  {user?.roleDto?.roleId === 3 && (
                    <div className="my-link">
                      <Link to="/change/login">로그인설정</Link>
                      {/* <Link to="#" onClick={() => props.logOut('/')}>
                      로그아웃
                    </Link> */}
                    </div>
                  )}

                  {/* //로그인후 */}
                </>
              ) : (
                <>
                  {/* 로그인전 */}
                  {/* <Link to="/login">로그인</Link> */}
                  <Link title="로그인" to="#" onClick={login}>
                    로그인
                  </Link>
                  <a href="https://wallet.utradehub.or.kr/regis/Join">회원가입</a>
                  {/* //로그인전 */}
                </>
              )}
            </div>
          </div>
        </div>
        {/* gnb */}
        <div id="gnb" onClick={gnbClickHandler}>
          <div className="tit">
            <p>
              디지털전자무역이
              <br /> 함께합니다.
            </p>
          </div>
          <ul>
            {/* <li className="menu01">
              <Link to="/service/certmng">증명서 신청</Link>
              <ul className="submenu">
                <li>
                  <Link to="/service/certmng">증명서 신청</Link>
                </li>
                <li>
                  <Link to="/service/bundle">꾸러미 신청</Link>
                </li>
                <li>
                  <Link to="/service/certissue">신청 현황</Link>
                </li>
              </ul>
            </li> */}
            {auth?.isLoggedIn && ['kcl','ktc','ktr','katri','kotiti','fiti','keiti','chemp'].includes(auth?.user?.payload?.memberId) ? (
                <>
                <li className="menu01">
                  <Link to="#">전자문서지갑</Link>
                  <ul className="submenu">
                    <li>
                      <Link to="/service/certbox/chemp/sendbox">보낸문서</Link>
                    </li>
                    <li>
                      <Link to="/service/certbox/chemp">받은문서</Link>
                    </li>
                  </ul>
                </li>
                <li className="menu02">
                  <Link to="/change/info">마이페이지</Link>
                  <ul className="submenu">
                    <li>
                      <Link to="/change/info">회원정보변경</Link>
                    </li>
                    <li>
                      <Link to="/change/pass">비밀번호변경</Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => props.showPwdPopup(true, 'link', '/company/info')}>사업자관리</Link>
                    </li>
                    {props.isShowPwdPopup && ( <PasswordConfirmModal requestType={props.requestType} value={props.value} onClose={() => props.showPwdPopup(false)} /> )}
                  </ul>
                </li>
                </>
            ) : (
              <>
              <li className="menu01">
                <Link to="/service/certbox">전자문서지갑</Link>
                <ul className="submenu">
                  <li>
                    <Link to="/service/certbox">내문서</Link>
                  </li>
                  <li>
                    <Link to="/service/sent">보낸문서</Link>
                  </li>
                  <li>
                    <Link to="/service/offical/EfDocument">공인전자문서</Link>
                  </li>
                  <li>
                    <Link to="/service/verify">증명서 진본검증</Link>
                  </li>
                </ul>
              </li>
              <li className="menu02">
                <Link to="/notice">고객센터</Link>
                <ul className="submenu">
                  <li>
                    <Link to="/notice">공지사항</Link>
                  </li>
                  <li>
                    <Link to="/faq">FAQ</Link>
                  </li>
                  <li>
                    <Link to="/question">문의하기</Link>
                  </li>
                  <li>
                    <Link to="/reference">자료실</Link>
                  </li>
                  <li>
                    <Link to="/guide">이용안내</Link>
                  </li>
                </ul>
              </li>
              {/*
                  roleId: 1(사업자/단체 관리자), 2(사업자/단체 사용자), 3(개인)
                  사업자관리      => roleId: 1
                  이용자관리      => roleId: 1
              */}
              {auth?.isLoggedIn ? (
                <li className="menu03">
                  <Link to="/change/info">마이페이지</Link>
                  <ul className="submenu">
                    <li>
                      <Link to="/change/info">회원정보변경</Link>
                    </li>
                    <li>
                      <Link to="/change/pass">비밀번호변경</Link>
                    </li>
                    {user?.roleDto?.roleId === 1 && (
                      <>
                        <li>
                          <Link to="#" onClick={() => props.showPwdPopup(true, 'link', '/company/info')}>사업자관리</Link>
                        </li>
                        <li>
                          <Link to="#" onClick={() => props.showPwdPopup(true, 'link', '/company/invite')}>이용자관리</Link>
                        </li>
                        {props.isShowPwdPopup && ( <PasswordConfirmModal requestType={props.requestType} value={props.value} onClose={() => props.showPwdPopup(false)} /> )}
                      </>
                    )}
                    <li>
                      <Link to="#" onClick={crtfctMng}>
                        인증서관리
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={ewalletIdCopy}>
                        <span id="myWallet">
                          <Clipboard data-clipboard-text={user.ewalletId} style={{ background: 'inherit' }}>
                            내지갑 주소복사
                          </Clipboard>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </li>
              ) : (
                ''
              )}
              </>
            )}
          </ul>
        </div>
        {/* //gnb */}

        {/* mobile button */}
        <button type="button" className="all-menu">
          <span className="line-wrap">
            <span className="line" />
            <span className="line" />
            <span className="line" />
          </span>
        </button>
        {/* nav mobile */}
        <section className="aside-wrap">
          <nav className="aside-nav">
            <div className="aside-header">
              <div className="member-link">
                {auth?.isLoggedIn ? (
                  ''
                ) : (
                  <>
                    <Link title="로그인" to="#" onClick={login}>
                      로그인
                    </Link>
                    <Link to="/regis/Join" onClick={hideAsideNav}>
                      회원가입
                    </Link>
                  </>
                )}
              </div>
              {auth?.isLoggedIn && (
                <div className="menu-link">
                  <Link to="/service/PushInfo" className="notify">
                    알림<em className="num">{props.pushData?.length > 0 ? props.pushData?.length : 0}</em>
                  </Link>
                  <Link to="/service/Setting" className="setting">
                    환경설정
                  </Link>
                  <span className="qr" onClick={qrLogin}>
                    QR코드
                  </span>
                </div>
              )}
            </div>
            <ul className="lnb">
              <li className="on">
                <Link to="/service/certmng">증명서 신청</Link>
                <ul className="submenu">
                  <li>
                    <Link to="/service/certmng" onClick={hideAsideNav}>
                      증명서 신청
                    </Link>
                  </li>
                  {/* { 모바일 앱에서 지갑 화면을 사용하기위한 URL 요청 } */}
                  {/* {<li>
                    <a onClick={() => openECDW('010100')}>정부전자문서지갑</a>
                  </li> } */}
                  <li>
                    <Link to="/service/bundle" onClick={hideAsideNav}>
                      꾸러미 신청
                    </Link>
                  </li>
                  <li>
                    <Link to="/service/certissue" onClick={hideAsideNav}>
                      신청 현황
                    </Link>
                  </li>
                </ul>
              </li>
              {Common.getDeviceType() == 'MobileApp'&&(
                <li>
                  <Link to="#">정부전자문서지갑</Link>
                  <ul className="submenu">
                    {/* 모바일 앱에서 지갑 화면을 사용하기위한 URL 요청 */}
                    <li>
                      <a href="#" onClick={() => openECDW('030100')}>
                        증명서신청
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => openECDW('030300')}>
                        증명서 신청 현황
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => openECDW('010100')}>
                        내증명서
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => openECDW('010200')}>
                        보낸내역
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => openECDW('010300')}>
                        받은증명서
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={() => openECDW('020100')}>
                        나의 지갑주소보기
                      </a>
                    </li>
                  </ul>
                </li>
              )}
              <li>
              
                {auth?.isLoggedIn ? <Link to="/service/certbox">전자문서지갑</Link> : <Link to="/loginintro">전자문서지갑</Link>}
                <ul className="submenu">
                  <li>
                    {/* <a href="#" onClick={hideAsideNav}> */}
                    <Link to="/service/certbox" onClick={hideAsideNav}>
                      내문서
                    </Link>
                    {/* </a> */}
                  </li>
                  <li>
                    <Link to="/service/sent" onClick={hideAsideNav}>
                      보낸문서
                    </Link>
                  </li>
                  <li>
                    <Link to="/service/offical/EfDocument/" onClick={hideAsideNav}>
                      공인전자문서
                    </Link>
                  </li>
                  <li>
                    <Link to="/service/verify" onClick={hideAsideNav}>
                      증명서 진본검증
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/service/verify" onClick={hideAsideNav}>
                  증명서 진본검증
                </Link>
              </li>
              {/* <li>
                <a href="https://dev-sign.utradehub.or.kr/m">전자계약</a>
              </li> */}
              <li>
                <Link to="/notice">고객센터</Link>
                <ul className="submenu">
                  <li>
                    <Link to="/notice" onClick={hideAsideNav}>
                      공지사항
                    </Link>
                  </li>
                  <li>
                    <Link to="/faq" onClick={hideAsideNav}>
                      FAQ
                    </Link>
                  </li>
                  <li>
                    <Link to="/question" onClick={hideAsideNav}>
                      문의하기
                    </Link>
                  </li>
                  <li>
                    <Link to="/reference" onClick={hideAsideNav}>
                      자료실
                    </Link>
                  </li>
                  <li>
                    <Link to="/guide" onClick={hideAsideNav}>
                      이용안내
                    </Link>
                  </li>
                </ul>
              </li>
              {/* 로그인후 */}
              {auth?.isLoggedIn ? (
                <li>
                  <a href="#">마이페이지</a>
                  <ul className="submenu">
                    <li>
                      {/* <a href="#">개인정보변경(탈퇴)</a> */}
                      <Link to="/change/info" onClick={hideAsideNav}>
                        회원정보변경
                      </Link>
                    </li>
                    <li>
                      <Link to="/change/pass" onClick={hideAsideNav}>
                        비밀번호변경
                      </Link>
                    </li>
                    {user?.roleDto?.roleId === 1 && (
                                        <>
                                          <li>
                                            <Link to="#" onClick={() => props.showPwdPopup(true, 'link', '/company/info')}>사업자관리</Link>
                                          </li>
                                          <li>
                                            <Link to="#" onClick={() => props.showPwdPopup(true, 'link', '/company/invite')}>이용자관리</Link>
                                          </li>
                                          {props.isShowPwdPopup && ( <PasswordConfirmModal requestType={props.requestType} value={props.value} onClose={() => props.showPwdPopup(false)} /> )}
                                        </>
                                      )}
                    <li className="dep-menu">
                      <a href="#">인증서 관리</a>
                      <ul>
                        <li>
                          <Link to="#" onClick={crtfctMng}>
                            공동인증서 관리
                          </Link>
                        </li>
                        {/* 인증서관리 > 사설인증서 관리 Tab */}
                        {/* <li>
                          <a href="/crtfct/mng?step=3">사설인증서 관리</a>
                        </li> */}
                      </ul>
                    </li>
                    <li>
                      {user?.roleDto?.roleId === 3 && (
                        <Link to="/change/login" onClick={hideAsideNav}>
                          로그인 설정
                        </Link>
                      )}
                    </li>
                    <li className="dep-menu" style={user?.roleDto?.roleId === 3 ? { display: 'block' } : { display: 'none' }}>
                      <a href="#">모바일 인증</a>
                      <ul>
                        <li> 
                          <a href="#" onClick={pinRegist}>
                            간편번호 등록
                          </a>
                        </li>
                        <li>
                          <a href="#" onClick={patternInfoAdd}>
                            패턴 등록
                          </a>
                        </li>
                        {/*  
                          <li>
                            <a href="#" onClick={bioCheck}>
                              생체인식 등록
                            </a>
                          </li> 
                        */}
                      </ul>
                    </li>
                  </ul>
                </li>
              ) : (
                ''
              )}
              {/* 로그인후 */}
            </ul>
            <div className="aside-btm">
              {/* {Common.getDeviceType() === 'MobileApp' && (
                <a href="#" className="uth" onClick={openUth}>
                  UTH 모바일
                </a>
              )} */}
              {Common.getDeviceType()=='MobileApp' &&(
                  <div style={{color:'#fff'}}>
                    V.{window.M.info.app("app.version")}
                  </div>
                )
              }
              {auth?.isLoggedIn && (
                <Link className="logout" to="#" onClick={() => props.logOut('/')}>
                  로그아웃
                </Link>
              )}
            </div>
            <div className="close">
              <a href="#" className="btn-menu">
                닫기
              </a>
            </div>
          </nav>
          <div className="page-overlay" />
        </section>
        {/* //nav mobile */}
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    deviceId: state.auth.deviceId,
    userInfo: state.userinfo?.data,
    signData : state.userinfo?.signData,
    screenURL: state.govcertapply?.screenURL,
    verifyIndiECDWResult: state.govcertapply?.verifyIndiECDWResult,
    issueIndiECDWResult: state.govcertapply?.issueIndiECDWResult,
    inquireIndiECDWPopupListResult: state.govcertapply?.inquireIndiECDWPopupListResult,
    changeIndiECDWInfoResult: state.govcertapply?.changeIndiECDWInfoResult,
    inquireIndiStipAgreeResult: state.govcertapply?.inquireIndiStipAgreeResult,
    pushData: state.setting?.settingInfo?.cnt,
    isShowPwdPopup: state.auth.showPwdPopup,
  }
}

const actionCreators = {
  load: userinfoActions.load,
  setSignData : userinfoActions.setSignData,
  getDeviceId: authActions.getDeviceId,
  confirm: alertActions.confirm,
  logOut: authActions.logOut,
  count: mobileActions.count,
  error: alertActions.error,
  getScreenURL: govCertapplyActions.getScreenURL,
  verifyIndiECDW: govCertapplyActions.verifyIndiECDW,
  issueIndiECDW: govCertapplyActions.issueIndiECDW,
  inquireIndiECDWPopupList: govCertapplyActions.inquireIndiECDWPopupList,
  changeIndiECDWInfo: govCertapplyActions.changeIndiECDWInfo,
  inquireIndiStipAgree: govCertapplyActions.inquireIndiStipAgree,
  pushload: memberAppActions.load,
  showPwdPopup: authActions.showPwdPopup,
  checkPwd: authActions.checkPwd,
}

export default connect(mapStateToProps, actionCreators)(DefaultHeader)
